import React from "react";
import { number, string } from "prop-types";

const ExternalLinkIcon = ({ color = "#121212", width = 14, height = 14 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14">
    <path
      id="Path_155"
      d="M15.444 15.444H4.556V4.556H9V3H4.556A1.555 1.555 0 0 0 3 4.556v10.888A1.555 1.555 0 0 0 4.556 17h10.888A1.56 1.56 0 0 0 17 15.444V11h-1.556zM11.556 3v1.556h2.792L6.7 12.2l1.1 1.1 7.646-7.646v2.79H17V3z"
      fill={color}
      data-name="Path 155"
      transform="translate(-3 -3)"
    />
  </svg>
);

ExternalLinkIcon.propTypes = {
  width: number,
  height: number,
  color: string
};

export default ExternalLinkIcon;
